import BaseClient from '@/app/model/api/response/baseApiClient'

class StageUpdateApi extends BaseClient {
  public updateStage (bodyData: {[key: string]: string|number}) {
    const path = '/v1/field/stage'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new StageUpdateApi()
